import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { RohsComponentComplianceFileDetailView } from '@/shared/hooks/api/rohsComplianceFiles'
import {
  useRunCatalogRohsComponentTestReportAudit,
  useRunRohsComponentTestReportAudit,
} from '@/shared/hooks/api/rohsComplianceFiles'
import { V2ComponentRohsTestReportAuditSheet } from './V2ComponentRohsTestReportAuditSheet'
import { V2ComponentRohsTestReportAuditSummaryCard } from './V2ComponentRohsTestReportAuditSummaryCard'

type V2ComponentRohsTestReportAuditPanelProps = {
  componentId: string
  file: RohsComponentComplianceFileDetailView
  canWrite: boolean
  auditInProgress: boolean
  scope: 'catalog' | 'product'
  productId?: string
}

export function V2ComponentRohsTestReportAuditPanel({
  componentId,
  file,
  canWrite,
  auditInProgress,
  scope,
  productId,
}: V2ComponentRohsTestReportAuditPanelProps) {
  const { i18n } = useTranslation('common')
  const [sheetOpen, setSheetOpen] = useState(false)
  const runCatalog = useRunCatalogRohsComponentTestReportAudit(componentId)
  const runProduct = useRunRohsComponentTestReportAudit(
    productId ?? '',
    componentId
  )
  const runMutation = scope === 'catalog' ? runCatalog : runProduct

  const testSlot = file.slots.find((slot) => slot.slotKind === 'TEST_REPORT')
  const hasTestReport = testSlot?.fileName != null
  const latest = file.latestTestReportAudit
  const isRunning = auditInProgress || runMutation.isPending

  if (!hasTestReport) {
    return null
  }

  return (
    <>
      <V2ComponentRohsTestReportAuditSummaryCard
        latest={latest}
        isRunning={isRunning}
        locale={i18n.language}
        onOpen={() => {
          setSheetOpen(true)
        }}
      />
      <V2ComponentRohsTestReportAuditSheet
        open={sheetOpen}
        onOpenChange={setSheetOpen}
        componentId={componentId}
        file={file}
        canWrite={canWrite}
        auditInProgress={auditInProgress}
        scope={scope}
        productId={productId}
      />
    </>
  )
}
